import { SET_WARRANTY_NUMBER_CODE } from './types';

const initialState = {
  warrantyNumberCode: '',
};

export const warrantyNumberCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WARRANTY_NUMBER_CODE:
      return { ...state, warrantyNumberCode: action.payload };
    default:
      return state;
  }
};
